import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-family-history-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './family-history-section.component.html',
})
export class FamilyHistorySectionComponent {
  readonly familyHistories = input.required<any[]>();

  getStatus(fh: any): string {
    return fh.status || '';
  }

  getRelationship(fh: any): string {
    return (
      fh.relationship?.coding?.[0]?.display ||
      fh.relationship?.coding?.[0]?.code ||
      fh.relationship?.text ||
      '—'
    );
  }

  getConditions(fh: any): any[] {
    return fh.condition || [];
  }

  getConditionName(cond: any): string {
    return (
      cond.code?.text || cond.code?.coding?.[0]?.display || cond.code?.coding?.[0]?.code || '—'
    );
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'completed') return { color: 'bg-success', label: 'Completado' };
    if (s === 'partial') return { color: 'bg-warning text-dark', label: 'Parcial' };
    if (s === 'unknown') return { color: 'bg-secondary', label: 'Desconocido' };
    return { color: 'bg-info', label: status || '—' };
  }
}
